import React, { useEffect, useState } from 'react';
import axios from "axios";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useNavigate } from "react-router-dom";
import logo from '../../assets/logo.svg';
import { useAuth } from "../../context/AuthProvider";
import { ADMIN_USERS, DEV_ADMIN_USERS, BASE_URL } from "../../constant/index";
import youtubeFilled from '../../assets/youtubeFilled.svg';
import twitterFilled from '../../assets/twitterFilled.svg';
import OTPMobileVerify from './OTPMobileVerify';
import OTPEmailVerify from './OTPEmailVerify';

const Header = () => {
  const [openMobileModal, setMobileOpen] = useState(false);
  const [openEmailModal, setEmailOpen] = useState(false);
  const { logOut, userEmail, userName, userMobile, token } = useAuth();
  const [ userNotifications, setUserNotifications ] = useState([]);
  const navigate = useNavigate();

  const onMenuSelection = (e) => {
    const selection = e.target.value;
    if (selection === 'logout') {
      logOut();
    } else if (selection === 'changePwd') {
      return navigate("/change-password");
    } else if (selection === 'updateProfile') {
      return navigate("/update-profile");
    } else if (selection === 'admin') {
      return navigate("/admin/ctdev");
    }
  }

  let displayName;
  if(userName) {
    displayName = userName;
  } else if(userEmail) {
    displayName = userEmail;
  }

  const isDemat = true;

  const handleMobileClose = () => setMobileOpen(false);

  const handleEmailClose = () => setEmailOpen(false);

  const fetchNotifications = async () => {
    try {
      let userInput;
      if (userEmail) {
        userInput = userEmail;
      } else if (userMobile) {
        userInput = userMobile;
      } else {
        return; // No user input available
      }

      if (!token || !userInput) {
        return;
      }

      const response = await axios.post(BASE_URL + '/getAllNotifications', { userInput }, { 
        headers: {
          "Authorization": `Bearer ${token}`,
        }
      });
      const notifications = response?.data;
      if(notifications) {
        const { isEmailVerified, isMobileVerified, adminNotifications } = notifications;
        const allNotifications = [];
        if(isEmailVerified === 0 || !isEmailVerified) {
          allNotifications.push(
            <>
              Unlock full access! Verify your email with a one-time code.{" "}
              <a 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  setEmailOpen(true);
                }}
              >
                 Generate OTP.
              </a>{" "}
            </>
          );
        }
        
        if(isMobileVerified === 0 || !isMobileVerified) {
          allNotifications.push(
            <>
              Unlock full access! Verify your phone number with a one-time code.{" "}
              <a 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  setMobileOpen(true);
                }}
              >
                 Generate OTP.
              </a>{" "}
            </>
          );
        }

        if(adminNotifications && adminNotifications.length > 0) {
          adminNotifications.forEach((notif) => {
            if (notif.status === 1) {
              allNotifications.push(notif.title);
            }
          });
        }
        setUserNotifications(allNotifications);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }

  useEffect(() => {
    fetchNotifications();
  }, [userEmail, userName]);
  
  return (
    <>
    <div className="container">
      <nav className="navbar navbar-expand-lg bg-body-white">
        <div className="container-fluid">
          <a className="navbar-brand header-brand" href="/home">
            <img src={logo} alt="Capital Trends" />
          </a>

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active textColor" aria-current="page" href="/home">Home</a>
              </li>

              {
                !displayName && (
                  <li className="nav-item dropdown">
                    <div className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Tools
                    </div>
                    <ul className="dropdown-menu">
                      <li><a className="dropdown-item" href="/marketDashboard">Market Dashboard</a></li>
                      <li><a className="dropdown-item" href="/patternRecognition">Pattern Recognition</a></li>
                      {/* <li><a className="dropdown-item" href="/swingTrades">Swing Trades</a></li> */}
                    </ul>
                  </li>
                )
              }

              <li className="nav-item">
                <a className="nav-link active textColor" aria-current="page" href="/1-1-Coaching">1:1 Coaching</a>
                {/* <span className="new-badge">Free</span> */}
              </li>
              
              <li className="nav-item">
                <a className="nav-link active textColor" aria-current="page" href="/contact-us">Contact</a>
              </li>

              {
                ADMIN_USERS.includes(userEmail) && (
                  <li className="nav-item">
                    <a className="nav-link active textColor" aria-current="page" href="/blogs">Blog</a>
                  </li>
                )
              }

              <li className="nav-item" style={{ paddingTop: '6px'}}>
                <a href="https://www.youtube.com/@TradeWithParvesh" target="alt">
                  <span className="px-2">
                    <img src={youtubeFilled} alt="youtube"/>
                  </span>
                </a>
              </li> 

              <li className="nav-item" style={{ paddingTop: '6px'}}>
                <a href="https://twitter.com/CapitalTrends/" target="alt">
                  <span className="px-2">
                    <img src={twitterFilled} alt="twitter" />
                  </span>
                </a>
              </li>
            </ul>
            {
              !userEmail && (
                <div className="d-flex header-auth-actions">
                  <a className="btn btn-primary button-cus me-2" type="submit" href={`/sign-up?isDemat=${isDemat}`}>Open a Demat Account</a>
                  <a className="btn btn-outline-primary me-2" type="submit" href="/sign-in">Login</a>
                  <a className="btn btn-primary button-cus" type="submit" href="/sign-up">Sign up</a>
                </div>
              )
            }

            {
              userEmail && (
                <div className="d-flex user_logged_in">
                  <div className="welcome_user">
                    Welcome {displayName}
                  </div>
                  <div className="header-right-container">
                    <form>
                      <select className="styled-select" name="userMenu" id="userMenu" onChange={onMenuSelection}>
                        <option value='0'>Please select</option>
                        <option value="updateProfile" >Update Profile</option>
                        <option value="changePwd">Change Password</option>
                        {
                          DEV_ADMIN_USERS.includes(userEmail) && (
                            <option value="admin">Admin Panel</option>
                          )
                        }
                        <option value="logout">Logout</option>
                      </select>
                    </form>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </nav>
    </div>
    {
      displayName && userNotifications?.length > 0 && (
        <div className="container">
          <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert severity="info">
              <ul>
                {
                  userNotifications.map((note, index) => (
                    <li key={index}>{note}</li>
                  ))
                }
              </ul>
            </Alert>
          </Stack>
      </div>
      )
    }
   
    {
      openMobileModal && (
        <OTPMobileVerify openModal={openMobileModal} handleClose={handleMobileClose} setOpen={setMobileOpen} fetchNotifications={fetchNotifications} />
      )
    }
    {
      openEmailModal && (
        <OTPEmailVerify openModal={openEmailModal} handleClose={handleEmailClose} setOpen={setEmailOpen} fetchNotifications={fetchNotifications} />
      )
    }
    </>
  )
}

export default Header;
